<mat-card class="mat-elevation-z{{_elevation}}"
	[ngClass]="{'mat-snack-bar-container app-acrylic': _elevation > -1}"
	[fxLayout]="isInline ? 'row' : 'column'"
	[fxLayoutAlign]="isInline ? 'start center' : 'center start'">

	<img alt="illustration" mat-card-image fxFlexAlign="center" *ngIf="notification.image" [src]="notification.image" loading="lazy" />

	<mat-card-content fxFlex="auto" fxLayout="row" style="margin-bottom: 0" fxLayoutAlign="start center" [ngClass]="{
			'mat-green': notification.type === 'success' && _elevation <= -1,
			'mat-green-300': notification.type === 'success' && _elevation > -1,
			'mat-red': notification.type === 'warn' && _elevation <= -1,
			'mat-red-300': notification.type === 'warn' && _elevation > -1,
			'mat-primary': !['success', 'warn'].includes(notification.type) && _elevation <= -1,
			'mat-grey-300': !['success', 'warn'].includes(notification.type) && _elevation > -1
		}">

		<mat-icon @animated fxFlex="1 1 28px" inline class="mat-notification-icon" *ngIf="notification.icon || notification.type">
			{{(notification.icon ? notification.icon : (notification.type === 'success' ? 'check_circle' : 'error'))}}
		</mat-icon>

		<div fxLayout="column" class="mat-notification-content" fxFlex="1 1 auto">
			<div *ngIf="notification.type || notification.title" class="mat-title">
				{{(notification.title ? notification.title : (
					notification.type === 'success' ? 'Réussi' : 'Echec'))}}
			</div>
			<div *ngIf="notification.message" style="white-space: pre-wrap">{{notification.message}}</div>
		</div>

		<button mat-icon-button *ngIf="notification.canClose && !isInline" (click)="close()" class="mat-notification-close">
			<mat-icon>close</mat-icon>
		</button>
	</mat-card-content>

	<mat-card-content *ngIf="notification.progress !== undefined" style="margin: 16px 0 0 0">
		<div *ngIf="notification.progress === 'indeterminate'" class="app-pong">
            <div class="app-pong-dot"></div>
            <div class="app-pong-dot"></div>
            <div class="app-pong-dot"></div>
        </div>
		<mat-progress-bar *ngIf="notification.progress !== 'indeterminate'" mode="determinate" [value]="notification.progress"></mat-progress-bar>
	</mat-card-content>
	
	<mat-card-actions *ngIf="notification?.actions?.length" fxLayout="row" fxLayoutAlign="end center" 
		[fxFlexAlign]="isInline ? 'center' : 'end'" style="padding: 0 !important;" [ngStyle]="{margin: isInline ? '0 0 0 16px' : '16px 0 0 0'}">
		<button mat-button *ngFor="let action of notification.actions" (click)="action.action(); close();"
			[ngStyle]="{
				'margin-bottom.px': (isInline ? 0 : -8),
				'margin-left.px': (isInline ? 8 : 0)
			}">
			{{action.text}}
		</button>
	</mat-card-actions>

	<button mat-icon-button *ngIf="notification.canClose && isInline" (click)="close()" class="mat-notification-close">
		<mat-icon>close</mat-icon>
	</button>
</mat-card>